<h2 *ngIf="data.title" mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content *ngIf="data.content"><p>{{ data.content }}</p></mat-dialog-content>
<mat-dialog-actions fxLayoutAlign="end start">
  <button mat-button color="primary" (click)="closeDialog()">{{ cancelLabel | translate }}</button>
  <button cdkFocusInitial mat-button color="primary" (click)="closeDialog(true)">{{ confirmLabel | translate }}</button>
</mat-dialog-actions>
